import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

const styles = (theme) => ({
    addOnsBox: {
        width: '100%',
        height: '56px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',

        border: '1px solid #dfdfdf',
        borderRadius: '4px',
        backgroundColor: '#fff',
        marginBottom: '16px',
        color: '#00000061',
    },

    addOnsName: {
        marginLeft: '16px',
    },

    addOnsValue: {
        marginRight: '16px',
        fontWeight: 'bold',
    },

    linkPointer: {
        cursor: 'pointer',
    },

    boxStyling: {
        backgroundColor: '#ffffff',
        padding: 24,
        borderRadius: 4,
        boxShadow: theme.customShadows.widget,
    },

    boxSpace: {
        marginTop: '24px',
    },

    dateField: {
        justifyContent: 'space-between',
        marginBottom: 47,

        '& .MuiFormControl-root': {
            width: '100%',
        },
    },

});

export default styles;
export const useStyles = makeStyles(styles);
